module.exports = __webpack_public_path__ + "img/20200514_143429.51e34482.jpg";